import { custom, success } from "./utilities";
import { ToastifyService, boatTypeService } from "../../services";
import { boatTypeConstants, globalSystemConstants } from "../../constants";

const gridData = {
  length: 10,
  pageNumber: 1,
  orderBy: "id desc",
  filterQuery: null,
  search: null,
};

export const getBoatTypes = () => {
  return (dispatch) => {
    boatTypeService
      .getBoatTypes()
      .then((response) =>
        dispatch(success(response, boatTypeConstants.BOAT_TYPE_DATA))
      )
      .catch((error) => ToastifyService.showError(error));
  };
};

export const getClasses = () => {
  return (dispatch) => {
    boatTypeService
      .getClasses()
      .then((response) =>
        dispatch(success(response, boatTypeConstants.BOAT_TYPE_UNOFFICIAL_DATA))
      )
      .catch((error) => ToastifyService.showError(error));
  };
};

export const getAllBoatClass = (gridData) => {
  return (dispatch) => {
    dispatch(
      custom(
        boatTypeConstants.GET_SPINNER,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    boatTypeService
      .getAllBoatClass(gridData)
      .then((response) =>
        dispatch(success(response, boatTypeConstants.BOAT_CLASS_DATA))
      )
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(
          custom(
            boatTypeConstants.GET_SPINNER,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

export const getBoatClassById = (id) => {
  return (dispatch) => {
    dispatch(
      custom(boatTypeConstants.SPINNER, globalSystemConstants.SPINNER_ACTIVATE)
    );
    boatTypeService
      .getBoatClassById(id)
      .then((response) => {
        dispatch(success(response, boatTypeConstants.BOAT_CLASS_DATA_BY_ID));
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(
            boatTypeConstants.SPINNER,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

export const addBoatClass = (BoatClassData, onSuccess) => {
  return (dispatch) => {
    dispatch(
      custom(boatTypeConstants.SPINNER, globalSystemConstants.SPINNER_ACTIVATE)
    );
    boatTypeService
      .addBoatClass(BoatClassData)
      .then((response) => {
        if (response) {
          dispatch(getAllBoatClass({ ...gridData, filterQuery: "id != null" }));
          if (onSuccess) {
            onSuccess();
          }
          ToastifyService.showSuccess(response);
        }
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(
          custom(
            boatTypeConstants.SPINNER,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

export const updateBoatClass = (BoatClassData, onSuccess) => {
  return (dispatch) => {
    dispatch(
      custom(boatTypeConstants.SPINNER, globalSystemConstants.SPINNER_ACTIVATE)
    );
    boatTypeService
      .updateBoatClass(BoatClassData)
      .then((response) => {
        if (response) {
          dispatch(getAllBoatClass({ ...gridData, filterQuery: "id != null" }));
          if (onSuccess) {
            onSuccess();
          }
          ToastifyService.showSuccess(response);
        }
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(
          custom(
            boatTypeConstants.SPINNER,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

export const deleteBoatClassById = (id, onSuccess) => {
  return (dispatch) => {
    dispatch(
      custom(boatTypeConstants.SPINNER, globalSystemConstants.SPINNER_ACTIVATE)
    );
    boatTypeService
      .deleteBoatClassById(id)
      .then((response) => {
        if (response) {
          dispatch(getAllBoatClass({ ...gridData, filterQuery: "id != null" }));
          if (onSuccess) {
            onSuccess();
          }
          ToastifyService.showSuccess(response);
        }
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(
          custom(
            boatTypeConstants.SPINNER,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

export const getAllGenderBoatClass = () => {
  return (dispatch) => {
    dispatch(
      custom(boatTypeConstants.SPINNER, globalSystemConstants.SPINNER_ACTIVATE)
    );
    boatTypeService
      .getAllGenderBoatClass()
      .then((response) =>
        dispatch(success(response, boatTypeConstants.GET_ALL_GENDER_BOAT_CLASS_DATA))
      )
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(
          custom(
            boatTypeConstants.SPINNER,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

export const boatTypeActions = {
  getBoatTypes,
  getClasses,
  getAllBoatClass,
  getBoatClassById,
  addBoatClass,
  updateBoatClass,
  deleteBoatClassById,
  getAllGenderBoatClass,
};
